











































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";

@Component({
  components: {
    Add,
  },
})
export default class extends Mixins(MyList) {
  dispatchType = "sms/list";

  // 发送结果:1-等待发送；2-发送成功；3-发送失败
  statusOption: any[] = [
    { id: "1", name: "等待发送" },
    { id: "2", name: "发送成功" },
    { id: "3", name: "发送失败" },
  ];

  // 短信类型：1-系统通知；2-订单通知；3-平台充值通知；4-场馆充值通知；
  smsTypeOption: any[] = [
    { id: "1", name: "系统通知" },
    { id: "2", name: "订单通知" },
    { id: "3", name: "平台充值通知" },
    { id: "4", name: "场馆充值通知" },
    { id: "5", name: "短信群发" },
    { id: "9", name: "登录验证码" },
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "手机号", scopedSlots: { customRender: "mobile" } },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "类型", scopedSlots: { customRender: "sms_type" } },
    { title: "内容", scopedSlots: { customRender: "content" } },
    { title: "平台", scopedSlots: { customRender: "sms_platform" } },
    { title: "平台承担费用", scopedSlots: { customRender: "sms_platformPic" } },
    { title: "馆长承担费用", scopedSlots: { customRender: "sms_namePic" } },
    { title: "发送时间", dataIndex: "send_time" },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  mounted() {
    this.loadData();
  }
}
